import { ActionTypes } from '../Actions/Actions';
import * as fromActions from '../Actions/Actions';

export interface IStateTracking {
    tracked: string[];
}

export const defaultStateTracking: IStateTracking = {
    tracked: [],
};
export const StateTracking = (
    state = defaultStateTracking,
    action: fromActions.Actions
): IStateTracking => {
    switch (action.type) {
        case ActionTypes.GAME_TRACKING:
            const t = [...state.tracked];
            t.push(action.payload);
            return {
                ...state,
                tracked: t,
            };
        default:
            return state;
    }
};
